import ab from 'src/replicant/ruleset/ab';
import { ChannelProperty } from './analytics/properties';
import { tryLocalStorage, tryToSetItemToLocalStorage } from './tryLocalStorage';
import { GCInstant } from 'src/lib/gcinstant';
import StateObserver from 'src/StateObserver';
import { getDynamicTestBucket } from 'src/replicant/getters/ab';
import { PetEvolutionStage, PetSpeciesID } from 'src/replicant/pet/pet.ruleset';

export type DemoTestBucket =
  | 'control'
  | 'afterFirstPuzzle'
  | 'afterTutorial'
  | undefined;

const DEMO_FIRST_ENTRY_INFO_KEY = 'Buruburu_demoFirstEntryInfo';
type DemoFirstEntryInfo = {
  $channel: ChannelProperty;
  $adCampaignName?: string;
  $adSetName?: string;
  $adCreativeName?: string;
  $adNetworkName?: string;
  creativeAssetID?: string;
  creativeCTA?: string;
  creativeTextID?: string;
};

export function setDemoFirstEntryInfoToLocalStorage() {
  const payload = {
    $channel: GCInstant.entryData?.$channel,
    $adCampaignName: GCInstant.entryData?.$adCampaignName,
    $adSetName: GCInstant.entryData?.$adSetName,
    $adCreativeName: GCInstant.entryData?.$adCreativeName,
    $adNetworkName: GCInstant.entryData?.$adNetworkName,
    $creativeAssetID: GCInstant.entryData?.creativeAssetID,
    $creativeCTA: GCInstant.entryData?.creativeCTA,
    $creativeTextID: GCInstant.entryData?.creativeTextID,
  };

  // Filter out undefined values
  const filteredPayload = Object.fromEntries(
    Object.entries(payload).filter(([, value]) => value !== undefined),
  );

  tryToSetItemToLocalStorage(
    DEMO_FIRST_ENTRY_INFO_KEY,
    JSON.stringify(filteredPayload),
  );
}
export function getDemoFirstEntryInfo(): DemoFirstEntryInfo | undefined {
  const info = tryLocalStorage()?.getItem(DEMO_FIRST_ENTRY_INFO_KEY);
  if (!info) {
    return undefined;
  }

  return JSON.parse(info) as DemoFirstEntryInfo;
}

/**
 * Get local state from demo game to export it to real state
 */
export type DemoState = {
  bucketId_331: string | undefined;
  petName: string;
  petEvolutions: readonly {
    species: PetSpeciesID;
    stage: PetEvolutionStage;
    timestamp: number;
  }[];
  tos: Record<string, { acceptedAt: number }> | undefined;
};

/**
 * Get local state from demo game to export it to payload
 */
export function getDemoState(): DemoState {
  const state = StateObserver.getState().user;

  return {
    bucketId_331:
      getDynamicTestBucket(state, ab.tests.TEST_DEMO_MODE) || undefined,
    petName: state.pet.name ?? 'Potepote',
    petEvolutions: state.pet.evolutions ?? [],
    tos: (state.platformStorage?.tos as any) ?? undefined,
  };
}
